export const WEIGHT_UNITS = [
  { value: 'kg', label: 'common.kilogram' },
  { value: 'ton', label: 'common.metric_ton' },
  { value: 'quintal', label: 'common.quintal' },
];

export const AREA_UNITS = [
  { value: 'acre', label: 'common.units.acre' },
  { value: 'hectare', label: 'common.units.hectare' },
  { value: 'bigha', label: 'common.units.bigha' },
];

export const VOLUME_UNITS = [
  { value: 'liter', label: 'common.units.liter' },
  { value: 'ml', label: 'common.units.ml' },
];

export const PRICE_UNITS = [
  { value: 'per_kg', label: 'common.units.perKg' },
  { value: 'per_quintal', label: 'common.units.perQuintal' },
  { value: 'per_ton', label: 'common.units.perTon' },
];

// Common conversion factors
export const UNIT_CONVERSIONS = {
  kg_to_quintal: 0.01,
  kg_to_ton: 0.001,
  kg_to_maund: 0.025,
  quintal_to_kg: 100,
  ton_to_kg: 1000,
  maund_to_kg: 40,
};
